module.exports = __webpack_public_path__ + "img/meat.429d04c4.svg";